import React, { useEffect, useState } from 'react';

import { Icon } from 'selfly-ui-react';
import Tag from 'selfly-ui-react/dist/components/Tag';

import './viewBody.scss';
import CrudView from '../components/Crud/CrudView';
import ValidatingInput from '../components/ValidatingInput/ValidatingInput';
import OwnerSelector from '../components/OwnerSelector/OwnerSelector';
import LocationTypeSelector from '../components/LocationTypeSelector/LocationTypeSelector';
import ParentSelector from '../components/ParentSelector/ParentSelector';

export default function LocationCrudView(props) {
    // const [filters, setFilters] = useState([
    //     {
    //         id: 'showDeleted',
    //         name: 'Deleted',
    //         icon: 'filter_list',
    //         value: false,
    //         buttonType: 'negative',
    //         filterFn: (items, filter) => {
    //             if (!filter.value) {
    //                 return items.filter(it => it.status !== 'Deleted');
    //             }
    //             return items;
    //         },
    //         buttonClick: showDeleted,
    //     },
    // ]);

    const columns = [
        {
            key: 'name',
            title: 'Name',
            className: 'auto-medium smaller-text',
            onClickEditRow: true,
            content: item => {
                const nameText = typeof item.name === 'string' && item.name.length > 0 ? item.name : item.code;
                return (
                    <>
                        <span>{nameText}</span>
                    </>
                );
            },
        },
        {
            key: '',
            title: '',
            className: 'fix-mini',
            onClickOpenChildren: true,
            content: item => {
                const childCount = item.children && item.children.length > 0 ? item.children.length : null;
                return (
                    <>
                        {childCount && (
                            <span className="flexible-content-center">
                                <Tag>
                                    {childCount} <Icon>arrow_drop_down</Icon>
                                </Tag>
                            </span>
                        )}
                    </>
                );
            },
        },
        {
            key: 'type',
            title: 'Type',
            className: 'fix-100  smaller-text',
            onClickOpenChildren: true,
        },
        {
            key: 'status',
            title: 'Status',
            content: (val, item) => {
                if (val.status === 'Deleted') {
                    return <span style={{ color: 'red' }}>{val.status}</span>;
                }
                return <span style={{ color: 'green' }}>{val.status}</span>;
            },
            className: 'fix-100  smaller-text',
        },
        {
            key: 'owners',
            title: 'Visible to',
            className: 'fix-medium  smaller-text',
        },
    ];

    // function showDeleted(origFilter) {
    //     const filter = { ...origFilter };
    //     filter.value = !filter.value;
    //     filter.buttonType = filter.value ? 'positive' : 'negative';
    //     setFilters(
    //         filters.map(fl => {
    //             if (fl.id !== filter.id) return fl;
    //             return filter;
    //         })
    //     );
    // }


    return <CrudView serviceId="LocationService"
     form={LocationForm}
      title="Location"
       columns={columns}
        filters={null}
         viewMode="TREE"></CrudView>;
}

function LocationForm(props) {
    const [invFields, setInvalidFields] = useState([]);
    const [locationData, setlocationData] = useState(() => {
        if (props.item) {
            const data = { ...props.item };
            data.name = data.name !== null ? data.name : '';
            data.type = data.type !== null ? data.type : '';
            data.parentLocationCode = data.parentLocationCode !== null ? data.parentLocationCode : '';
            data.owners = !data.owners || !Array.isArray(data.owners) ? [] : data.owners;
            return data;
        }
        return {
            name: 'Default name',
            status: 'Active',
            id: null,
            owners: '',
        };
    });

    useEffect(() => {
        const invalidFields = [];

        /**
         *
         * @param {any} val The string value
         * @param {number} minLen Minimum length of the string
         * @param {number} maxLen Maximum length of the string
         * @param {boolean} mandatory If the validation is mandatory to save changes
         */
        function isValidString(val, minLen, maxLen, mandatory = false) {
            if (typeof val !== 'string') return false;
            if (mandatory || val.length > 0) {
                if (val.length < minLen || val.length > maxLen) return false;
                return true;
            }
            return true;
        }

        function isMultiSelectItemValid(val, minLen, maxLen, mandatory) {
            if (!val || !Array.isArray(val)) return false;
            if (mandatory || val.length > 0) {
                if (val.length < minLen || val.length > maxLen) return false;
                return true;
            }
            return true;
        }

        !isValidString(locationData.code, 3, 1000, true) && invalidFields.push('code');
        !isValidString(locationData.name, 4, 1000, true) && invalidFields.push('name');
        !isValidString(locationData.type, 1, 30, true) && invalidFields.push('type');
        !isValidString(locationData.parentLocationCode, 1, 1000) && invalidFields.push('parent');

        !isMultiSelectItemValid(locationData.owners, 1, 10, true) && invalidFields.push('owners');

        props.onChange(locationData, invalidFields.length === 0);

        setInvalidFields(invalidFields);
        // eslint-disable-next-line
    }, [locationData, props.onChange]);

    // function onToggleChange(value, name) {
    //     const newData = typeof locationData === 'object' ? { ...locationData } : {};
    //     newData[name] = value;
    //     // props.onChange(newData);
    //     setlocationData(newData);
    // }

    function changeValue(key, value, valid) {
        const newData = typeof locationData === 'object' ? { ...locationData } : {};
        newData[key] = value;
        // props.onChange(newData);
        setlocationData(newData);
    }

    function onOwnerChange(key, value) {
        const newData = typeof locationData === 'object' ? { ...locationData } : {};
        if (Array.isArray(value) ) {
            newData[key] = value.map(val => val.value);
            if (JSON.stringify(newData) !== JSON.stringify(locationData)) {
                // props.onChange(newData);
                setlocationData(newData);
            }
        }
    }

    function onSingleSelectChange(key, value) {
        const newData = typeof locationData === 'object' ? { ...locationData } : {};
        newData[key] = value.value;
        // props.onChange(newData);
        setlocationData(newData);
    }
    return (
        <div className="crud-form-container">
            {invFields.length > 0 && (
                <div className="crud-validation-errors">
                    There are invalid field values or mandatory fields are missing.
                    <br />
                    Invalid fields are: {invFields.join(', ')}.
                </div>
            )}

            {props.crudState.viewMode === 'NEW' && (
                <div className="crud-input">
                    <ValidatingInput
                        label="location code"
                        dataSet={locationData}
                        dataKey="code"
                        onChange={changeValue}
                        validationType="string"
                        validationFn={val => {
                            return val.length > 2;
                        }}
                    />
                    <div className="crud-help">Unique Code for the location</div>
                </div>
            )}

            <div className="crud-input">
                <ValidatingInput label="Name" dataSet={locationData} dataKey="name" onChange={changeValue} validationType="string" />
                <div className="crud-help">Name of the location</div>
            </div>

            {/* <div className="crud-input">
                <div className="se-input-container">
                    <label className="se-label se-lable--md">Active</label>
                    <Toggle
                        label="Active"
                        isActive={locationData.status === 'Active'}
                        onChange={val => {
                            onToggleChange(val ? 'Active' : 'Inactive', 'status');
                        }}
                    />
                </div>
            </div> */}

            <div className="crud-input with-group">
                <div className="input-group">
                    <OwnerSelector label="Visible to" dataSet={locationData} dataKey="owners" onChange={onOwnerChange} validationType="multiselect" />
                    <LocationTypeSelector label="Type" dataSet={locationData} dataKey="type" onChange={onSingleSelectChange} validationType="select" />
                    <ParentSelector
                        label="Parent"
                        serviceId={props.crudState.serviceId}
                        dataSet={locationData}
                        dataKey="parentLocationCode"
                        onChange={onSingleSelectChange}
                        validationType="select"
                    />
                </div>
                <div className="crud-help">The main address of the location</div>
            </div>

            {/*          
            <div className="crud-input">
                <ValidatingInput label="Meta data as json" dataKey="metadata" dataSet={locationData} onChange={updateMetadata} validationType="json" />

                <div className="crud-he">Meta data as Json file</div>
            </div> 
            */}
        </div>
    );
}
